// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setUserSearch,
  resetUserSearch
} from 'src/store/modules/admin/userSearch'

const initialState = []

export default handleActions(
  {
    [setUserSearch](__, { payload: billingSummary }) {
      return billingSummary
    },

    [resetUserSearch]() {
      return initialState
    }
  },
  initialState
)
